import OrderItem from './OrderItem';

export { default as SinglePageOrderItem } from './SinglePageOrderItem';
export default OrderItem;
